/** QuantisAI's Bots view: the person's bot tasks, scheduled runs and what bots
 * remember, kept out of the chat itself. It is the only bot screen a member
 * has, so it lives in the panel every role can open. */
import { useState } from 'react';
import { SIBotTasks } from './SIBotTasks';
import { SIBotSchedules } from './SIBotSchedules';
import { SIBotMemory } from './SIBotMemory';

const TASKS_SHOWN = 20;

export function SIBotsView({ workspaceId }: { workspaceId: string }) {
  const [reload, setReload] = useState(0);
  return (
    <div className="min-h-0 flex-1 overflow-y-auto px-4 py-3" aria-label="Bots">
      <SIBotTasks key={workspaceId} workspaceId={workspaceId} refreshKey={reload} limit={TASKS_SHOWN} emptyText="No bot tasks yet." />
      <SIBotSchedules key={`schedules:${workspaceId}`} workspaceId={workspaceId} onRan={() => setReload((n) => n + 1)} />
      <SIBotMemory key={`memory:${workspaceId}`} workspaceId={workspaceId} />
    </div>
  );
}
